import { render, staticRenderFns } from "./carousel-case.vue?vue&type=template&id=79a980d6&"
import script from "./carousel-case.vue?vue&type=script&lang=js&"
export * from "./carousel-case.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports